import { render, staticRenderFns } from "./DependencyFilterStructure.vue?vue&type=template&id=3a316d0e&scoped=true&"
import script from "./DependencyFilterStructure.vue?vue&type=script&lang=js&"
export * from "./DependencyFilterStructure.vue?vue&type=script&lang=js&"
import style0 from "./DependencyFilterStructure.vue?vue&type=style&index=0&id=3a316d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a316d0e",
  null
  
)

export default component.exports